import React, { useState, useImperativeHandle, forwardRef } from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom'

//images
import closeIcon from '../../../assets/images/profile/close-icon.png';
import completeTestImg from '../../../assets/images/profile/complete-test-img.jpg';

function CompletedTest(props, ref) {

    const [major, setMajor] = useState({
        blur: false,
        popup: false,
        href: '',
    })

    useImperativeHandle(ref, () => ({
        open: href => {
            handleOpen(href)
        },
        close: () => {
            handleClose()
        }
    }))

    const handleOpen = href => {
        setMajor(major => ({
            ...major,
            blur: true,
            href: href
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                popup: true
            }))
        }, 50);
    }

    const handleClose = () => {
        setMajor(major => ({
            ...major,
            popup: false
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                blur: false,
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={major.blur ? 'visible' : ''}>
            <div className={`box profile-complete-test complete-test ${major.popup ? 'show' : ''}`}>
                <img
                    src={closeIcon}
                    className="close"
                    alt="Затваряне"
                    title="Затваряне"
                    onClick={handleClose}
                    style={{ height: '16px' }}
                />
                <img src={completeTestImg} className="main-img" />
                <h3>
                    Гледай Видео лекциите от Тема 1
                </h3>
                <p>
                    Виж резултатите от теста или реши отново, за да затвърдиш своите знания до момента.
                </p>
                <div className="buttons">
                    <Button className="btn-secondary">
                        <Link to="/test?topic_id=1&result=1">
                            Виж резултата от последния решен тест
                        </Link>
                    </Button>
                    <Button className="btn-secondary">
                        <Link to="/test?topic_id=1">
                            Реши последния тест отново
                        </Link>
                    </Button>
                    <Button>
                        <Link to="/topic?topic_id=1&video_id=o59AvgSd" onClick={handleClose}>
                            Към видео лекциите от Тема 1
                        </Link>
                    </Button>
                </div>
            </div>
        </div >
    )
}

export default forwardRef(CompletedTest);